import { CdpConnectionFindParameters, CdpConnectionFindResponse } from "../app/shared/models/layout/cdp/connection/find/CdpConnectionFind";

export function response(params : CdpConnectionFindParameters): CdpConnectionFindResponse {
    if(params.iccid) return data.find(i => i.cmd.params.iccid === params.iccid);
    if(params.id) return data.find(i => i.cmd.params.id === params.id);
    return null;
}

const data: CdpConnectionFindResponse[] = [{
   cmd: {
      success: true,
      params: {
        id: "58c213fdbafd035684783f65",
        orgId: "52fbed495d80f1091b00000f",
        ownerOrgId: "52fbed495d80f1091b00000f",
        permission: "rw",
        configId: "5640fdb5b2157c7d917fd71b",
        identity: "ICCID: 8912345678901234567890",
        iccid: "8912345678901234567890",
        carrier: "AT&T",
        terminalId: "B0129DB1",
        imsi: "310410705599151",
        imei: "356144040370849",
        msisdn: "5886392515",
        ratePlan: "50MB Evaluation Plan",
        ratePlanId: 3438,
        status: "activated",
        dateAdded: "2014-08-25T10:49:24Z",
        dateModified: "2016-08-09T12:33:15Z",
        estimatedMonthData: 16.763265609741,
        usageMonthData: 14.959177017212,
        apn: "a105.2way.net",
        inSession: true,
        ipAddress: "10.21.3.134",
        session: {
          dataMO: 22675813,
          dataMT: 19995596,
          dateStart: "2019-03-29T12:25:33.06Z",
          ipAddress: "10.17.91.115"
        },
        ggsnMccMnc: "310410",
        ggsnCountry: "United States",
        ggsnNetwork: "AT&T Wireless Inc.",
        sgsnMccMnc: "310410",
        sgsnCountry: "United States",
        sgsnNetwork: "AT&T Wireless Inc.",
        radioAccessTech: "UTRAN",
        locLat: 26.39525,
        locLng: -80.11353,
        locAddress: {
          streetNumber: "",
          street: "5300 Broken Sound Blvd",
          city: "Boca Raton",
          state: "FL",
          zipCode: "33487",
          country: "US"
        },
        locFixType: "network",
        customer: "ILSTECH",
        hasDataUsage: true,
        cdp: {
          deviceType: "SIM-2FF",
          contractId: 47312,
          networkId: 601,
          networkCode: "AT:3G:DAT",
          id1: "5886392515",
          ratePlanCode: "ATEV50MB",
          regStatus: "Activated",
          created: "2014-08-25T10:49:24",
          updated: "2017-08-09T12:33:15",
          custom1: "Option CloudGate"
        },
          switchEnabled: true,
          remoteAtEnabled: true,
          tags: [
             "tag1"
        ],
        lastSync: {
          general: "2019-03-29T07:10:14.01Z",
          session: "2019-03-29T15:14:17.059Z",
          location: "2019-03-29T14:50:36.272Z",
          dataUsage: "2019-03-29T07:09:28.536Z",
          smsUsage: "2019-03-29T14:33:40.791Z"
        },
        createdOn: "2017-03-10T02:48:29.1Z",
        updatedBy: "admin@devicewise.com",
        updatedOn: "2019-02-27T11:06:32.758-04:00",
      }
   }
},
{
  cmd: {
     success: true,
     params: {
       id: "58c213fdbafd035684783f68",
       orgId: "52fbed495d80f1091b00000f",
       ownerOrgId: "52fbed495d80f1091b00000f",
       permission: "rw",
       configId: "5640fdb5b2157c7d917fd71b",
       identity: "ICCID: 8912345678901234567891",
       iccid: "8912345678901234567891",
       carrier: "AT&T",
       terminalId: "B0129DB1",
       imsi: "310410705599151",
       imei: "356144040370849",
       msisdn: "5886392515",
       ratePlan: "50MB Evaluation Plan",
       ratePlanId: 3438,
       status: "activated",
       dateAdded: "2014-08-25T10:49:24Z",
       dateModified: "2016-08-09T12:33:15Z",
       estimatedMonthData: 16.763265609741,
       usageMonthData: 14.959177017212,
       usageMonthSms:2,
       usageMonthVoice: 100,
       apn: "a105.2way.net",
       inSession: true,
       ipAddress: "10.21.3.134",
       session: {
         dataMO: 22675813,
         dataMT: 19995596,
         dateStart: "2019-03-29T12:25:33.06Z",
         ipAddress: "10.17.91.115"
       },
       ggsnMccMnc: "310410",
       ggsnCountry: "United States",
       ggsnNetwork: "AT&T Wireless Inc.",
       sgsnMccMnc: "310410",
       sgsnCountry: "United States",
       sgsnNetwork: "AT&T Wireless Inc.",
       radioAccessTech: "UTRAN",
       locLat: 26.39525,
       locLng: -80.11353,
       locAddress: {
         streetNumber: "",
         street: "5300 Broken Sound Blvd",
         city: "Boca Raton",
         state: "FL",
         zipCode: "33487",
         country: "US"
       },
       locFixType: "network",
       customer: "ILSTECH",
       hasDataUsage: true,
       cdp: {
         deviceType: "SIM-2FF",
         contractId: 47312,
         networkId: 601,
         networkCode: "AT:3G:DAT",
         id1: "5886392515",
         ratePlanCode: "ATEV50MB",
         regStatus: "Activated",
         created: "2014-08-25T10:49:24",
         updated: "2017-08-09T12:33:15",
         custom1: "Option CloudGate"
       },
         switchEnabled: true,
         remoteAtEnabled: true,
         tags: [
            "tag1"
       ],
       lastSync: {
         general: "2019-03-29T07:10:14.01Z",
         session: "2019-03-29T15:14:17.059Z",
         location: "2019-03-29T14:50:36.272Z",
         dataUsage: "2019-03-29T07:09:28.536Z",
         smsUsage: "2019-03-29T14:33:40.791Z"
       },
       createdOn: "2017-03-10T02:48:29.1Z",
       updatedBy: "admin@devicewise.com",
       updatedOn: "2019-02-27T11:06:32.758-04:00",
     }
  }
},
{
    cmd: {
       success: true,
       params: {
         id: "58c213fdbafd035684783f22",
         orgId: "52fbed495d80f1091b00000f",
         ownerOrgId: "52fbed495d80f1091b00000f",
         permission: "rw",
         configId: "5640fdb5b2157c7d917fd71b",
         identity: "ICCID: 8912345678901234567891",
         iccid: "89562008019000000245",
         carrier: "AT&T",
         terminalId: "B0129DB1",
         imsi: "310410705599151",
         imei: "356144040370849",
         msisdn: "5886392515",
         ratePlan: "50MB Evaluation Plan",
         ratePlanId: 3438,
         status: "activated",
         dateAdded: "2014-08-25T10:49:24Z",
         dateModified: "2016-08-09T12:33:15Z",
         estimatedMonthData: 16.763265609741,
         usageMonthData: 14.959177017212,
         usageMonthSms:2,
         usageMonthVoice: 100,
         apn: "a105.2way.net",
         inSession: true,
         ipAddress: "10.21.3.134",
         session: {
           dataMO: 22675813,
           dataMT: 19995596,
           dateStart: "2019-03-29T12:25:33.06Z",
           ipAddress: "10.17.91.115"
         },
         ggsnMccMnc: "310410",
         ggsnCountry: "United States",
         ggsnNetwork: "AT&T Wireless Inc.",
         sgsnMccMnc: "310410",
         sgsnCountry: "United States",
         sgsnNetwork: "AT&T Wireless Inc.",
         radioAccessTech: "UTRAN",
         locLat: 26.39525,
         locLng: -80.11353,
         locAddress: {
           streetNumber: "",
           street: "5300 Broken Sound Blvd",
           city: "Boca Raton",
           state: "FL",
           zipCode: "33487",
           country: "US"
         },
         locFixType: "network",
         customer: "ILSTECH",
         hasDataUsage: true,
         cdp: {
           deviceType: "SIM-2FF",
           contractId: 47312,
           networkId: 601,
           networkCode: "AT:3G:DAT",
           id1: "5886392515",
           ratePlanCode: "ATEV50MB",
           regStatus: "Activated",
           created: "2014-08-25T10:49:24",
           updated: "2017-08-09T12:33:15",
           custom1: "Option CloudGate"
         },
           switchEnabled: true,
           remoteAtEnabled: true,
           tags: [
              "tag1"
         ],
         lastSync: {
           general: "2019-03-29T07:10:14.01Z",
           session: "2019-03-29T15:14:17.059Z",
           location: "2019-03-29T14:50:36.272Z",
           dataUsage: "2019-03-29T07:09:28.536Z",
           smsUsage: "2019-03-29T14:33:40.791Z"
         },
         createdOn: "2017-03-10T02:48:29.1Z",
         updatedBy: "admin@devicewise.com",
         updatedOn: "2019-02-27T11:06:32.758-04:00",
       }
    }
  },



]
